module.exports = __webpack_public_path__ + "media/images/icons/ic-dropdown-old-9a410faa425a18bdb080c57c39d89a30.svg";